import { render, staticRenderFns } from "./disclaimers.vue?vue&type=template&id=b0acf2a0&scoped=true&"
import script from "./disclaimers.vue?vue&type=script&lang=js&"
export * from "./disclaimers.vue?vue&type=script&lang=js&"
import style0 from "./disclaimers.vue?vue&type=style&index=0&id=b0acf2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0acf2a0",
  null
  
)

export default component.exports